import { Component } from "@angular/core";

@Component({
  selector: "app-digital-cards",
  templateUrl: "./digital-cards.component.html",
  styleUrls: ["./digital-cards.component.scss"],
  standalone: false,
})
export class DigitalCardsComponent {}
